import { render, staticRenderFns } from "./CreaCliente.vue?vue&type=template&id=8edb2bc8&scoped=true&"
import script from "./CreaCliente.vue?vue&type=script&lang=js&"
export * from "./CreaCliente.vue?vue&type=script&lang=js&"
import style0 from "./CreaCliente.vue?vue&type=style&index=0&id=8edb2bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edb2bc8",
  null
  
)

export default component.exports